import { BrandInfoProps } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/BrandInfo/brandInfoProps";
import { ILeanProductTile } from "@faire/web-api--source/indigofair/data/ILeanProductTile";

export const brandInfoProductTileAdaptor = (params: {
  productTile: ILeanProductTile;
  productSearchString: string;
  brand: ILeanProductTile.IBrand | undefined;
  isLoggedInRetailer: boolean;
  isBatch10ProductTilesV4?: boolean;
}): BrandInfoProps => {
  const {
    productTile,
    brand,
    productSearchString,
    isLoggedInRetailer,
    isBatch10ProductTilesV4,
  } = params;
  return {
    token: productTile.product?.token,
    brandToken: productTile.product?.brand_token ?? brand?.token,
    impressionId: productTile.product?.impression_id,
    selectedProductOptionToken: productTile.selected_product_option_token,

    brandName: brand?.name,
    brandIcon: brand?.icon,
    minimumOrderAmount: brand?.minimum_order_amount,
    catalogSizeText: brand?.catalog_size,

    insiderBadgeProps: {
      insiderBenefits: brand?.insider_benefits,
      insiderLabelText: brand?.insider_label?.text,
    },

    isPromoted: productTile.product?.is_promoted,
    promotedBy: productTile.product?.promoted_by ?? [],
    brandPromoText: productTile.brand_promo_text,
    avgBrandReviewRating: productTile.product?.avg_brand_review_rating,
    brandReviewCount: productTile.product?.brand_review_count,
    isHighlightedProductForPromotionalEvent:
      productTile.is_highlighted_product_for_promotional_event,
    badgeList: productTile.badge_list,
    bestImage: productTile.best_image,
    images: productTile.images,

    isLoggedInRetailer: isLoggedInRetailer,
    flagCountryCode: brand?.flag_country_code,
    shipsFromMessage: brand?.ships_from_message,
    productSearchString,
    isBatch10ProductTilesV4,
  };
};
